import { Grid, withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import {
    UpdateClaimKeyTaxDeclaration,
    updateClaimKeyTaxDeclarationAction,
} from '../../actions/update-claim-key-tax-declaration';
import { requiredValidator } from '../../../forms/validations';
import { getLifeAssuredDetails } from '../../../life-assured-details/reducer';
import { State } from '../../../redux/root-reducer';
import styles, { StyledComponent } from '../../../styles/styles';
import { OnSubmitSuccessProps } from '../../../workflow-navigation';
import {
    FormErrors,
    FormHeading,
    FullWidthRadioGroup,
    GenericForm,
    RadioOption,
} from '../../../forms';

interface Props extends StyledComponent, OnSubmitSuccessProps {
    keyTaxDirectiveDeclaration?: string;
    updateClaimKeyTaxDeclaration: UpdateClaimKeyTaxDeclaration;
}

const KeyTaxDeclarationForm = GenericForm<{ keyTaxDirectiveDeclaration: string }>();
const keyTaxDirectiveDeclarationEditView: React.FunctionComponent<Props> = ({
    keyTaxDirectiveDeclaration,
    updateClaimKeyTaxDeclaration,
    ...rest
}: Props) => {
    return (
        <KeyTaxDeclarationForm
            onSubmit={updateClaimKeyTaxDeclaration}
            initialValues={{ keyTaxDirectiveDeclaration }}
            {...rest}
        >
            <Grid container justify="flex-start">
                <Grid item xs={12}>
                    <FormHeading text="Tax Directive Feedback" />
                </Grid>
                <Grid item xs={6}>
                    <FullWidthRadioGroup
                        name="keyTaxDirectiveDeclaration"
                        label="Have you applied for a Tax directive on KeyTax?"
                        validate={requiredValidator}
                    >
                        <RadioOption value="Yes" />
                        <RadioOption value="No" />
                    </FullWidthRadioGroup>
                </Grid>
            </Grid>
            <FormErrors />
        </KeyTaxDeclarationForm>
    );
};

const mapStateToProps = (state: State) => ({
    keyTaxDirectiveDeclaration: getLifeAssuredDetails(state).keyTaxDirectiveDeclaration,
});

const mapDispatchToProps = {
    updateClaimKeyTaxDeclaration: updateClaimKeyTaxDeclarationAction,
};

export const KeyTaxDirectiveDeclarationEditView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(keyTaxDirectiveDeclarationEditView));
